<template>
  <Page title="To-Do List">
    <template #actions>
      <div
        class="d-flex align-items-end flex-wrap datatable-report-actions todos-filter-container"
      >
        <Button
          text="New To-Do"
          icon="fas fa-plus"
          data-cy="create-todo-btn"
          @click="toggleTodoModal"
        />
      </div>
    </template>
    <TabSwitcher id="todos" :tabs="tabs" @tab-change="handleTabChange" />
    <ToDoModal
      v-if="todoModal"
      :to-do="selectedTodo"
      @hide-modal="toggleTodoModal"
      @refresh-todos="refreshData"
    />
  </Page>
</template>

<script>
import { mapActions } from "vuex";
import { EventBus } from "@/lib/event_bus.js";
import { getQueryVariables } from "@/lib/url.js";

import Button from "@/components/Button.vue";
import Page from "@/components/Page.vue";
import TabSwitcher from "@/components/TabSwitcher/TabSwitcher.vue";
import DatatableFilter from "@/Reports/DatatableFilter.vue";
import ToDoModal from "./ToDoModal.vue";
import ToDos from "./ToDos.vue";

export default {
  components: {
    TabSwitcher,
    Page,
    Button,
    ToDoModal,
    DatatableFilter
  },
  props: {
    filters: {
      type: Array,
      default: () => []
    },
    source: {
      type: String,
      default: ""
    },
    sourceAssigned: {
      type: String,
      default: ""
    },
    sourceCreated: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      todoModal: false,
      selectedTodo: {},
      currentTab: ""
    };
  },
  computed: {
    tabs() {
      return [
        {
          id: "AssignedTab",
          name: "Assigned to Me",
          component: ToDos,
          props: {
            source: this.sourceAssigned,
            recordFilter: "assigned_to",
            filters: this.currentFilters
          }
        },
        {
          id: "CreatedByTab",
          name: "Created by Me",
          component: ToDos,
          props: {
            source: this.sourceCreated,
            recordFilter: "created_by",
            filters: this.currentFilters
          }
        },
        {
          id: "AllTodosTab",
          name: "All To-Dos",
          component: ToDos,
          props: {
            source: this.source,
            filters: this.filters
          }
        }
      ];
    },
    currentFilters() {
      return this.currentTab === "All To-Dos"
        ? this.filters
        : this.filters.filter((filter) => filter.type === "toggle");
    },
    todosCount() {
      return this.sourceAssigned.length;
    }
  },
  mounted() {
    EventBus.$on("edit-to-do", this.handleEditToDo);
    const { tab, todo_id } = getQueryVariables();
    this.currentTab = tab ? this.parseTabName(tab) : this.tabs[0].name;

    if (todo_id) {
      this.handleEditToDo(todo_id);
    }
  },
  beforeUnmount() {
    EventBus.$off("edit-to-do", this.handleEditToDo);
  },
  methods: {
    ...mapActions(["fetchTodo"]),
    toggleTodoModal() {
      this.todoModal = !this.todoModal;
      if (!this.todoModal) {
        this.selectedTodo = {};
      }
    },
    handleEditToDo(toDoId) {
      this.fetchTodo(toDoId).then((response) => {
        this.selectedTodo = response.data;
      });
      this.toggleTodoModal();
    },
    refreshData() {
      EventBus.$emit("refresh-todos-table");
    },
    handleTabChange(tabName) {
      this.currentTab = tabName;
    },
    parseTabName(queryTabName) {
      return queryTabName.split("_")[1].replaceAll("+", " ");
    }
  }
};
</script>

<style lang="scss">
.todos-filter-container {
  display: flex;
  align-items: flex-end;
}

//removes to-dos reports default padding
div#toDo_report.container-fluid {
  main {
    padding: 0px !important;
  }
}
</style>
